import { render, staticRenderFns } from "./ModelBuilder.vue?vue&type=template&id=cfd84820"
import script from "./ModelBuilder.vue?vue&type=script&lang=js"
export * from "./ModelBuilder.vue?vue&type=script&lang=js"
import style0 from "./ModelBuilder.vue?vue&type=style&index=0&id=cfd84820&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports